import { Box, Divider, Skeleton, Stack } from "@mui/material";
import Pagination from "components/pagination";
import cloneDeep from "lodash/cloneDeep";
import uniq from "lodash/uniq";
import * as React from "react";
import { Review } from "stores/useStore/useReviews";
import ItemReview from "./itemReview";

type Props = {
  handlePageChange: (page: number) => void;
  isLoading: boolean;
  reviews: Review[];
  pagination: any;
  refreshList: () => void;
};

export default function Reviews({
  handlePageChange,
  isLoading,
  reviews,
  pagination,
  refreshList,
}: Props): React.ReactElement {
  const [likes, setLikes] = React.useState([]);

  const afterLike = (id: string) => {
    const arr = cloneDeep(likes);
    arr.push(id);
    setLikes(uniq(arr));
    refreshList();
  };

  const onPageChange = (_, page) => {
    handlePageChange(page);
  };

  return (
    <Box
      sx={{
        // bgcolor: (theme) => theme.palette.grey[200],
        pb: 4,
      }}
    >
      {isLoading && (
        <Stack spacing={3} divider={<Divider />}>
          <LoadingBlock />
          <LoadingBlock />
          <LoadingBlock />
        </Stack>
      )}
      {!isLoading && (
        <Stack spacing={3} divider={<Divider />}>
          {reviews.map((review, index) => {
            return (
              <ItemReview
                review={review}
                key={index}
                afterLike={afterLike}
                likes={likes}
              />
            );
          })}
        </Stack>
      )}
      <Box
        sx={{
          borderTop: "1px solid",
          borderColor: "divider",
          mt: 3,
          pt: 3,
        }}
      >
        <Pagination pagination={pagination} onChange={onPageChange} />
      </Box>
    </Box>
  );
}

const LoadingBlock = () => {
  return (
    <Box>
      <Skeleton width={112} height={22.28} animation="wave" />
      <Skeleton width={160} height={24} animation="wave" sx={{ mt: 0 }} />
      <Skeleton
        height={60}
        variant="rectangular"
        animation="wave"
        sx={{ my: 1 }}
      />
      <Skeleton
        width={100}
        height={29}
        variant="rectangular"
        animation="wave"
      />
    </Box>
  );
};
